import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRow,{attrs:{"justify":"center","align":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b',[_vm._v(" "+_vm._s(_vm.t("accessDenied"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }